import { useSelector } from "react-redux";

const CanAccess = ({ roles = [], children }) => {
  const { user, role } = useSelector((state) => state.authentication);
  if (roles.length === 0 || !user || !roles.includes(role)) {
    return null;
  }
  return children;
};

export default CanAccess;
